import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20professional%20background%20with%20deep%20navy%20blue%20and%20soft%20sky%20blue%20gradient%20flowing%20organic%20shapes%20dynamic%20streaks%20of%20light%20creating%20a%20sense%20of%20forward%20momentum%20and%20aspiration%20minimalist%20modern%20design%20with%20subtle%20texture%20elegant%20and%20sophisticated%20corporate%20aesthetic&width=1800&height=1200&seq=hero-bg-career-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-950/30 to-primary-950/70" />

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-32 md:py-40">
        <div className="max-w-[900px] mx-auto text-center">
          <p className="font-heading italic text-accent-300 text-lg md:text-xl mb-6 tracking-wide">
            {t('hero.tagline')}
          </p>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            {t('hero.title1')}
            <br />
            <span className="text-accent-300">{t('hero.title2')}</span>
          </h1>

          <p className="text-base md:text-lg text-foreground-100/80 max-w-[620px] mx-auto leading-relaxed mb-10">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              onClick={() => navigate('/booking')}
              className="px-8 py-3.5 bg-white text-primary-700 font-semibold text-sm rounded-full hover:bg-accent-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta1')}
              <i className="ri-arrow-right-line ml-2" />
            </button>
            <button
              type="button"
              onClick={() => navigate('/services')}
              className="px-8 py-3.5 border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta2')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}